import React from 'react';

import {State} from '../../components/grid/BasicGridState'

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';
import "flatpickr/dist/l10n/pl.js"

import '../../components/grid/styles.scss';
import '../../components/grid/slickgrid.scss';
import '../../layouts/gridlayout.css'


import {
  SlickgridReactInstance, 
  GridStateChange, Metrics, Pagination, 
  Column, SlickDataView, Formatter, 
 EditCommand, GridState, EditorValidationResult, GridOption,
 FileType,
 DelimiterType
} from 'slickgrid-react';
import { SlickCompositeEditorComponent } from '@slickgrid-universal/composite-editor-component';
import { ExcelExportService } from '@slickgrid-universal/excel-export';


import i18next, { TFunction } from 'i18next';
import { GridOdataService, OdataServiceApi } from '@slickgrid-universal/odata';
import authService from '../../services/auth/auth.service';
import { SnackbarKey } from 'notistack';
import { Button } from '@mui/material';
import { GraphqlService, GraphqlServiceApi } from '@slickgrid-universal/graphql';
import { delimiter } from 'path';


export const defaultPageSize = 20;

export interface BasicGridProps{
    storage_key   :string,
    auto_edit_key : string,
  }

 // console.log(window.location)
  const location = window.location
  
  const locationley = location.pathname.replaceAll('/', '')
  const LOCAL_STORAGE_KEY = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-grid'
  const LOCAL_STORAGE_AUTO_EDIT = authService.getCurrentUser()?.shrt + '_crm-' + locationley +  '-auto-edit'
  const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-search' 
  const LOCAL_STORAGE_SEARCH_INCOGNITO = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-incognito-search' 
  const LOCAL_STORAGE_COLUMN_SIZE = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-column-size'
  const LOCAL_STORAGE_QUERY = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-query' 

  const LOCAL_STORAGE_GRID_CONFIG = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-grid-config'
  const LOCAL_STORAGE_CURRENT_GRID_CONFIG = authService.getCurrentUser()?.shrt + '_crm-' + locationley + '-current-grid-config'



export default class BaseGrid extends React.Component<BasicGridProps, State>   {
    storage_key!: string;
    auto_edit_key!: string ;
    search_key!:string;
    incognitoSearch_key!:string;
    columnsize_key!:string;
    query_key!:string;
    grid_config_key:string; 
    grid_currentconfig_key:string
    grid_currentconfig:string = ''

    excelExportService: ExcelExportService;


    compositeEditorInstance!: SlickCompositeEditorComponent ;
    reactGrid!: SlickgridReactInstance;

    protected _commandQueue: EditCommand[] = [];
    
    dataViewObj: SlickDataView | undefined;

    


    colorFormatter: Formatter = (_row, _cell, value) => {
        var rtn ={ text: "<div style='width:100%; height:100%; background-color:" + value + "'></div>",  toolTip: value };
        return rtn;
    };

    reactGridReady(reactGrid: SlickgridReactInstance) {
        this.reactGrid = reactGrid; 
        this.dataViewObj = reactGrid.dataView;        
    }
    

    saveCurrentGridState() {
        const gridState: GridState = this.reactGrid.gridStateService.getCurrentGridState();
        if (!this.state.incognito){
          localStorage[this.storage_key] = JSON.stringify(gridState);
          localStorage[this.auto_edit_key] = JSON.stringify(this.state.isAutoEdit);
        }
    }

    
   
    
    componentWillUnmount() {
        this.saveCurrentGridState();
    }


  
   // prop = BasicGridProps();
    validateCompositeEditors(targetElm: any) {
      var validationResults : EditorValidationResult = { valid: true, msg: "" };
        var currentEditor = this.reactGrid.slickGrid.getCellEditor();
  
        if (currentEditor) {
          validationResults = currentEditor.validate(targetElm);
        }
        return validationResults;
    }

    constructor(public readonly props: BasicGridProps) {

        super(props);
        this.auto_edit_key = LOCAL_STORAGE_AUTO_EDIT //props.auto_edit_key;
        this.storage_key = LOCAL_STORAGE_KEY //props.storage_key;
        this.search_key = LOCAL_STORAGE_SEARCH
        this.incognitoSearch_key = LOCAL_STORAGE_SEARCH_INCOGNITO
        this.columnsize_key = LOCAL_STORAGE_COLUMN_SIZE
        this.query_key = LOCAL_STORAGE_QUERY
        this.excelExportService =  new ExcelExportService();
        this.grid_config_key = LOCAL_STORAGE_GRID_CONFIG
        this.grid_currentconfig_key = LOCAL_STORAGE_CURRENT_GRID_CONFIG
        var grid_currentconfig : string = ''
        if (localStorage.getItem(this.grid_currentconfig_key)){
          
          grid_currentconfig = localStorage.getItem(this.grid_currentconfig_key) as string
        }

     
        this.compositeEditorInstance = new SlickCompositeEditorComponent();  
        
        var autoedit = true
        if ((localStorage[this.auto_edit_key] !==null) && (localStorage[this.auto_edit_key] !==undefined)){ 
            autoedit = JSON.parse(localStorage[this.auto_edit_key]); 
          }
        //var cc = props.auto_edit_key;
        //alert(cc);
        this.state = {
          gridOptions: undefined,
          columnDefinitions: [],
          dataset: [],
          paginationOptions: undefined,
          errorStatus: '',
          isCountEnabled: true,
          isSelectEnabled: false,
          isExpandEnabled: false,
          metrics: {} as Metrics,
          status: { class: '', text: '' },
          odataVersion: 4,
          odataQuery: '',
          processing: false,
          isPageErrorTest: false,
          alertWarning: '',
          alertInfo: '',
          alertError: '',
          alertErrorMsg:[],
          isAutoEdit: autoedit,
          lookupData: [],
          selectedLanguage : 'pl',
          searchQuery : '',
          incognito:false,
          configuration_state:grid_currentconfig,
          customEditor:""
        }; 
      }

      getColumnDefinitions(): Column[] {
        return []
      }
   
      displaySpinner(isProcessing: boolean, isError?: boolean) {
        this.setState((state: State) => ({ ...state, processing: isProcessing }));
    
        if (isError) {
          this.setState((state: State) => ({ ...state, status: { text: 'ERROR!!!', class: 'alert alert-danger' } }));
        } else {
          this.setState((state: State) => ({
            ...state,
            status: (isProcessing)
              ? { text: 'loading', class: 'alert alert-warning' }
              : { text: 'finished', class: 'alert alert-success' }
          }));
        }
      }

      postProcessCallback(data: any) {
        let totalItemCount: number = data['total']; // you can use "totalRecordCount" or any name or "odata.count" when "enableCount" is set
        this.setState((state: State) => ({
          ...state,
          paginationOptions: { ...state.gridOptions!.pagination, totalItems: totalItemCount } as Pagination,
          dataset: data['items'],
          metrics: { ...state.metrics, totalItemCount }
        }));
        this.reactGrid.eventPubSubService?.publish('onPaginationOptionsChanged', { ...this.state.gridOptions!.pagination, totalItems: totalItemCount } as Pagination, 1);
    }
    
  

    goToFirstPage() {
        this.reactGrid.paginationService!.goToFirstPage();
      }
    
      goToLastPage() {
        this.reactGrid.paginationService!.goToLastPage();
      }
    
      gridStateChanged(gridStateChanges: GridStateChange) {
        if (!this.state.incognito){
          localStorage[this.storage_key] = JSON.stringify(gridStateChanges.gridState); 
        } 
      }
    
      customizeHeaderMenu(tmp : Column<any>[] ){
        var key_exist=false;
        if (localStorage[this.columnsize_key]){
          var obj = JSON.parse(localStorage[this.columnsize_key])
          var dict = new Map(Object.entries(obj));
          key_exist=true;
        }

        tmp.forEach((columnDef) => {
          var col_frozen = false;
          if (key_exist){
          
            var col_width = dict.get(columnDef.field) as number
            if (col_width){
              columnDef.minWidth = col_width
              columnDef.maxWidth = col_width
              col_frozen=true
            }
          }
          columnDef.header = {
            menu: {
              commandItems: [
                {
                  iconCssClass: col_frozen ? 'fa fa-check' : 'fa fa-square', 
                  titleKey: 'Blokada szerokości', // use "title" as plain string OR "titleKey" when using a translation key
                  command: 'save_column',
                  tooltip: 'Zablokuj szerokość kolumny',
                  //cssClass: '',     // container css class
                  //textCssClass: (columnDef.id === 'title' || columnDef.id === 'completed') ? '' : 'blue', // just the text css class
                  positionOrder: 99,
                
                  action: (_e: Event, args: any) => {
                    var dict = new Map();
                    if (localStorage[this.columnsize_key]){
                      var obj = JSON.parse(localStorage[this.columnsize_key])
                      dict = new Map(Object.entries(obj));
                      var col_width = dict.get(columnDef.field) as number
  
                      if (col_width){
                        localStorage.removeItem(this.columnsize_key)
                        dict.delete(columnDef.field)
                        this.reactGrid.slickGrid.invalidate() 
                      }else{
                        dict.set(args.column.field, args.column.width);
                        
                      }
                      localStorage[this.columnsize_key] = JSON.stringify(Object.fromEntries(dict))
                    }else{
                      dict.set(args.column.field, args.column.width);
                      localStorage[this.columnsize_key] = JSON.stringify(Object.fromEntries(dict))
                    }
                    
                  
                    
                  }
                },
              
              ]
            }
          }
        });
        return tmp;
      }
      setFactorySettings(){
        localStorage.removeItem(this.columnsize_key)
        this.reactGrid.gridService.resetGrid(this.getColumnDefinitions());
        //this.reactGrid.paginationService!.changeItemPerPage(defaultPageSize);
    
        this.setState((state: State, props: BasicGridProps) => ({
          ...state,
          isAutoEdit:true,
        }));
        localStorage.setItem(this.grid_currentconfig_key, 'Domyślna')
    
        setTimeout(() => localStorage.removeItem(this.storage_key));
        setTimeout(() => localStorage.removeItem(this.auto_edit_key));
        
        window.location.reload();
    
      }
    
      throwPageChangeError() {
        this.setState(
          (state: State) => ({ ...state, isPageErrorTest: true }),
          () => this.reactGrid?.paginationService?.goToLastPage()
        );
      }

      autoeditchange(data:any){
        this.setState((state: State, props: BasicGridProps) => ({
          ...state,
          isAutoEdit:data,
        }));
    
        this.reactGrid.slickGrid.setOptions({autoEdit:data})
        localStorage[this.auto_edit_key] = JSON.stringify(data);
      }    
      


      getGridDefinition(state: State): GridOption {
          
        return {
            autoEdit: state.isAutoEdit,
            autoCommitEdit: false,
            editable: true,
            enableAutoResize: true,
            enableAddRow:true,
            enableGridMenu : true,
            //forceFitColumns: true,
           // autosizeColumnsByCellContentOnFirstLoad: false,
           // enableAutoResizeColumnsByCellContent: false,
            enableExcelExport : true,
            excelExportOptions: {
              sanitizeDataExport: true
            },
           // enableTextExport: true,
           // textExportOptions: {
           //   sanitizeDataExport: true
           // },
            externalResources: [this.excelExportService ],
            
            customFooterOptions: {
              metricTexts: {
                // default text displayed in the metrics section on the right
                // all texts optionally support translation keys,
                // if you wish to use that feature then use the text properties with the 'Key' suffix (e.g: itemsKey, ofKey, lastUpdateKey)
                // example "items" for a plain string OR "itemsKey" to use a translation key
                itemsKey: 'ITEMS',
                ofKey: 'OF',
                lastUpdateKey: 'LAST_UPDATE',
              },
              dateFormat: 'YYYY-MM-DD hh:mm a',
              hideTotalItemCount: false,
              hideLastUpdateTimestamp: false,
            },
            gridMenu: {
              commandTitle: 'Polecenia',
              columnTitle: ' ',
              iconCssClass: 'fa fa-ellipsis-v',
              menuWidth: 17,
              resizeOnShowHeaderRow: true,
    
              commandItems: [
                {command: 'best-fit', title : 'Dopasuj kolumny', positionOrder: 98},
               
              ///  {
                  // we can also have multiple nested sub-menus
                //  command: 'export', title: 'Export', positionOrder: 99,
                 
                  //commandItems: [
                  //  { command: 'exports-txt', title: 'Text (tab delimited)' },
                  //  {
                  //     command: 'sub-menu', title: 'Excel', cssClass: 'green', subMenuTitle: 'Dostępne formaty', subMenuTitleCssClass: 'text-italic orange',
                  //     commandItems: [
                  //       { command: 'exports-csv', title: 'Excel (csv)' },
                  //       { command: 'exports-xlsx', title: 'Excel (xlsx)' },
                  //    ]
                   // }
                 // ]
              //  },
              ],
    
              
            
              onCommand: (e, args) => {
                if (args.command === 'best-fit') {
                  this.reactGrid.resizerService.resizeGrid()
                }else if (args.command === 'exports-xlsx'){
                    this.excelExportService.exportToExcel({ filename: 'export', format: FileType.xlsx });
                }
              }
            },
            
            headerMenu: {
              hideColumnHideCommand : true,
              
              
            },
            compositeEditorOptions : {
              labels : {
                cancelButton: "Anuluj",
                cloneButton: "Kopiuj",
                massSelectionButton: "Zaktualizuj wybrane",
                resetEditorButtonTooltip: "Cofnij zmianę",
                resetFormButton: "Cofnij zmiany",
                
                saveButton: 'Zapisz'
              }
            },
        
            autoResize: {
                container: '#smaller-container',
                rightPadding: 10,
                bottomPadding:70
            },
            checkboxSelector: {
                hideInFilterHeaderRow: false,
                hideInColumnTitleRow: true
            },
            enableCompositeEditor:true,
            enableCellNavigation: true,
            enableFiltering: true,
            enableCheckboxSelector: true,
            enableRowSelection: true,
            enablePagination: true, // you could optionally disable the Pagination
            pagination: {
                pageSizes: [10, 20, 50, 200, 500, 1000, 2000, 50000],
                pageSize: defaultPageSize,
                totalItems: 0
            },
            backendServiceApi: {
                service: new GridOdataService(),
                options: {
                    enableCount: state.isCountEnabled, // add the count in the OData query, which will return a property named "__count" (v2) or "@odata.count" (v4)
                    enableSelect: state.isSelectEnabled,
                    enableExpand: state.isExpandEnabled,
                    version: state.odataVersion        // defaults to 2, the query string is slightly different between OData 2 and 4
              
                },      
            
            
          } as OdataServiceApi
            
        };
      }

      

}